export var Environment;
(function (Environment) {
    Environment["dev"] = "dev-graphql";
    Environment["prod"] = "prod-graphql";
    Environment["testing"] = "testing";
})(Environment || (Environment = {}));
//# sourceMappingURL=environment.js.map